<template>

  <div :style="style">
    <div class="MyvidioAll">
      <div class="prism-player" id="J_prismPlayer"></div>
      <!-- :src="'/safety/file/attachment/fileDownloadPart.htm?path='+videoSrc"  -->
      <!-- <video id="kcvideo" :currentTime="currentTime" :poster="kcdata.img" controlsList="nodownload"
        :src="wjSrc+videoSrc" height="100%" width="100%">
        您的浏览器不支持 video 标签。
      </video>
      <div class="playBtnBig">
        <i class="el-icon-video-play" v-if="!isPlay" @click="changePlay()"
          style="font-size: 160px;cursor: pointer;color: #fff;"></i>
        <i class="el-icon-video-pause" v-if="isPlay" @click="changePlay()"
          style="font-size: 160px;cursor: pointer;color: #fff;"></i>
      </div> -->
    </div>
    <div class="like-video-control" v-if="isBfkc">
      <div class="like-video-control-progress">
      </div>
    </div>

    <!-- 全屏 -->
    <el-dialog title="课程学习验证" :visible.sync="dialogVisibleQp" :append-to-body="false" :close-on-click-modal="false"
      :close-on-press-escape="false" :show-close="false" destroy-on-close :center="true" width="500px">
      <div style="text-align: center;">
        <div>请完成下方题目，<span style="color:#DB2020">60s</span>内未完成将退出课程学习</div>
        <div style="margin:30px auto 20px;"><img id="imgYzId" :src="yzmImg" @click="changeImg" /></div>
        <div>
          <el-input v-model="check_key" placeholder="请输入验证码计算结果" @focus="iserror = false"></el-input>
          <div v-if="iserror" style="color: red;text-align: left;">验证码输入错误，请重新填写验证码</div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirmQd()" class="YanzhenQdBtn">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 非全屏 -->
    <el-dialog title="课程学习验证" :visible.sync="dialogVisible" :append-to-body="true" :close-on-click-modal="false"
      :close-on-press-escape="false" :show-close="false" destroy-on-close :center="true" width="500px">
      <div style="text-align: center;">
        <div>请完成下方题目，<span style="color:#DB2020">60s</span>内未完成将退出课程学习</div>
        <div style="margin:30px auto 20px;"><img id="imgYzId" :src="yzmImg" @click="changeImg" /></div>
        <div>
          <el-input v-model="check_key" placeholder="请输入验证码计算结果" @focus="iserror = false"></el-input>
          <div v-if="iserror" style="color: red;text-align: left;">验证码输入错误，请重新填写验证码</div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirmQd()" class="YanzhenQdBtn">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import {
    formatTime
  } from '../../assets/js/common.js'
  export default {
    name: 'MyVideo',
    props: ['fullPageId', 'videoSrc', 'isFullpage', 'kcdata', 'isks', 'wjSrc', 'havezb'],
    data() {
      return {
        dialogVisible: false,
        dialogVisibleQp: false,
        progressTimer: '00:00:00',
        durationTimer: '00:00:00',
        isPlay: false,
        persenTimer: 0,
        currentTime: 0,
        videoProgress: 0,
        totalT: 0, //视频总时间
        style: {
          position: 'absolute',
          width: '100%',
          height: '100%'
        },
        isYz: false,
        yzmImg: '/safety/kt/pignumcont/getkt_check_jpg.htm?v=' + Math.random(),
        check_key: '',
        iserror: false,
        maxPercent: 0,
        draging: false,
        ischange: true,
        myplayer: null,
        bofangma: '',
        pwPass: '',
        isBfkc: false
      }
    },
    methods: {
      fullpage: function() {
        var isFullpage = false;
        var qpdiv = document.getElementById(this.fullPageId);
        if (this.isFullpage) {
          if (document.exitFullscreen) {
            document.exitFullscreen();
          } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
          } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
          } else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen();
          }
          isFullpage = false
          qpdiv.removeAttribute("controls")
        } else {
          if (qpdiv.requestFullscreen) {
            qpdiv.requestFullscreen();
          } else if (qpdiv.mozRequestFullScreen) {
            qpdiv.mozRequestFullScreen();
          } else if (qpdiv.webkitRequestFullscreen) {
            qpdiv.webkitRequestFullscreen();
          } else if (qpdiv.msRequestFullscreen) {
            qpdiv.msRequestFullscreen();
          }
          isFullpage = true;
          qpdiv.removeAttribute("controls")
        }
        this.$emit('childchange', isFullpage);
      },
      changePlay: function(flag) {
        var videoObj = document.getElementById('kcvideo');
        if (videoObj.paused) {
          // 如果视频处于播放状态
          videoObj.play();
          this.isPlay = true;
          this.ischange = false;
        } else {
          this.isPlay = false;
          videoObj.pause();
          // 暂停视频向后台提交视频的管控进度
          if (!flag) {
            this.$emit('saveProgress', {
              progressTimer: this.progressTimer,
              videoProgress: this.videoProgress
            }); //保存进度
          }
        }
      },
      changeProgress: function(val) {
        if (val) {
          this.draging = true;
          var nowTime = this.myplayer.getDuration();
          var percent = val;
          this.myplayer.seek(nowTime * percent * 0.01);
        } else {
          this.draging = false;
        };

        // this.videoProgress = val;

        // var videoObj = document.getElementById('kcvideo');
        // this.currentTime = (this.totalT / 100) * this.videoProgress;
        // var videoCurrent = formatTime(this.currentTime);
        // this.progressTimer = videoCurrent;
        // videoObj.currentTime = this.currentTime;
      },
      kaoshiYz: function() {
        var $this = this;
        if (this.isFullpage) {
          this.dialogVisibleQp = true;
        } else {
          this.dialogVisible = true;
        }
      },
      confirmQd: function() {
        // 图片验证码验证
        this.$axios.post('/kt/ktStudyRecord/check_and_add.htm?ktcount=' + this.check_key, null, {
          headers: {
            "X-Requested-With": "XMLHttpRequest",
          }
        }).then(res => {
          var data = res.data;
          if (data.stat == '1') {
            this.isYz = true;
            this.check_key = '';
            this.dialogVisible = false;
            this.dialogVisibleQp = false;
            this.myplayer.play();

            this.$emit('saveProgress', {
              progressTimer: this.progressTimer,
              videoProgress: this.videoProgress
            }); //保存进度
          } else {
            this.yzmImg = '/safety/kt/pignumcont/getkt_check_jpg.htm?v=' + Math.random();
            this.iserror = true;
          }
        })
      },
      changeImg: function() {
        this.yzmImg = '';
        this.yzmImg = '/safety/kt/pignumcont/getkt_check_jpg.htm?v=' + Math.random();
      },
      initVideo() {
        var _this = this;
        var myvid = this.kcdata.filepath;
        var mysource = this.bofangma;
        // this.myplayer && this.myplayer.pause();
        // this.myplayer.dispose();
        // this.myplayer = null;
        this.isBfkc = true;
        _this.myplayer = new Aliplayer({
          id: "J_prismPlayer", // 容器id
          vid: myvid,
          playauth: mysource,
          // source: _this.wjSrc+_this.videoSrc, //视频地址
          cover: this.kcdata.img, //播放器封面图
          autoplay: false, // 是否自动播放
          width: "100%", // 播放器宽度
          height: "454px", // 播放器高度
          playsinline: true,
          seekable: true,
          // 记忆播放器
          // components: [{
          //   name: 'MemoryPlayComponent',
          //   type: AliPlayerComponent.MemoryPlayComponent,
          //   /* Set the first parameter to true to enable auto play. The default is false. */
          //   args: [true,_this.getTime,_this.saveTime]
          // }],
          controlBarVisibility: 'always',
          skinLayout: [{
            "name": "bigPlayButton",
            "align": "cc"
            //"x": 30,
            //"y": 80
          }, {
            "align": "blabs",
            "x": 0,
            "y": 0,
            "name": "controlBar",
            "children": [{
                "align": "tl",
                "x": 15,
                "y": 12,
                "name": "playButton"
              }, {
                "align": "tl",
                "x": 10,
                "y": 5,
                "name": "timeDisplay"
              }, {
                "align": "tr",
                "x": 20,
                "y": 12,
                "name": "fullScreenButton"
              }, {
                "align": "tr",
                "x": 20,
                "y": 10,
                "name": "volume"
              },
              {
                "name": "progress",
                "align": "tlabs",
                "x": 0,
                "y": 0
              }
            ]
          }]
        })
        // 设置默认进度
        if (this.kcdata.finishtime) {
          var times = this.kcdata.finishtime;
          var arr1 = times.split(':');
          var seconds = parseInt(arr1[0]) * 60 * 60 + parseInt(arr1[1]) * 60 + parseInt(arr1[2]);
          this.progressTimer = times;
          this.videoProgress = this.kcdata.percent;
          _this.myplayer.seek(seconds);
        };

        _this.myplayer.on('ended', function() {
          // 播放片尾
          // _this.getVideoPianw()
          _this.$emit('saveProgress', {
            progressTimer: _this.kcdata.xstime,
            videoProgress: 100
          }); //保存进度
        });
        // 视频暂停
        _this.myplayer.on("pause", () => {
          var nowTime = _this.myplayer.getCurrentTime();
          _this.progressTimer = formatTime(nowTime);
          var percent = parseFloat((nowTime / _this.myplayer.getDuration()) * 100, 2);
          _this.$emit('saveProgress', {
            progressTimer: _this.progressTimer,
            videoProgress: percent
          }); //保存进度
        });
        // 视频播放事件
        _this.myplayer.on("timeupdate", () => {
          var nowTime = _this.myplayer.getCurrentTime();
          var videoCurrent = formatTime(nowTime);
          var percent = parseFloat((nowTime / _this.myplayer.getDuration()) * 100, 2);
          // 播放进度
          _this.$emit('changPercent', percent, videoCurrent);

          var presentT = _this.myplayer.getCurrentTime();
          // 验证是否是正在看视频  5分钟验证一次
          // 根据产品的字段是否防作弊（havezb=1）开启防作弊
          if (_this.havezb == '1') {
            if (presentT > 1 && (parseInt(presentT) / 60) % 10 == 0 && !_this.isYz) {
              _this.isYz = true;
              _this.isPlay = false;
              _this.kaoshiYz();
              _this.myplayer.pause();
            } else if (presentT > 1 && (parseInt(presentT) / 60) % 10 != 0) {
              _this.isYz = false;
            }
          };

        });

        var startTime = 0;
        if (this.kcdata.isfinish != 2) {
          // 用户未看完
          _this.myplayer.on("startSeek", (time) => {
            startTime = time.paramData;
          });
          _this.myplayer.on("completeSeek", (time) => {
            // 未看完   不可以快进
            if (time.paramData > startTime) {
              _this.$alert('您还没有看完，不可以快进播放！', '提示', {
                confirmButtonText: '确定',
                callback: action => {
                  _this.myplayer.seek(startTime);
                }
              });
            }
          });
        };
      },
      saveTime(memoryVideo, currentTime) {},
      getTime(memoryVideo) {
        return 20
      },
      getVideoVid() {
        // 获取课程的播放码
        this.$axios.get('/file/attachment/getPathFromDB.htm?id=' + this.kcdata.filepath, {
          headers: {
            "X-Requested-With": "XMLHttpRequest",
          }
        }).then(res => {
          this.bofangma = res.data;
          this.initVideo()
        });
        // 获取片尾的播放码
        // this.$axios.get('/file/attachment/getPathFromDB.htm?id=dc71da40a29171ed9d766eb3690d0102', {
        //   headers: {
        //     "X-Requested-With": "XMLHttpRequest",
        //   }
        // }).then(res => {
        //   this.pwPass = res.data;
        // });

      },
      // 用Aliplayer如何实现视频的连续播放
      // 播放片头
      getVideoPiant() {
        this.isBfkc = false;
        var myvid = "966f0810a29171ed84df34b6fdcb0102";
        var _this = this;
        this.$axios.get('/file/attachment/getPathFromDB.htm?id=' + myvid, {
          headers: {
            "X-Requested-With": "XMLHttpRequest",
          }
        }).then(res => {
          var mysource = res.data
          _this.myplayer = new Aliplayer({
            id: "J_prismPlayer", // 容器id
            vid: myvid,
            playauth: mysource,
            autoplay: false, // 是否自动播放
            width: "100%", // 播放器宽度
            height: "454px", // 播放器高度
            playsinline: true,
            seekable: true,
            controlBarVisibility: 'hover',
            skinLayout: [{
              "name": "bigPlayButton",
              "align": "cc"
            }]
          });
          _this.getVideoVid()
          _this.myplayer.on("ended", function() {
            _this.initVideo()
          });
        });
      },
      // 播放片尾
      getVideoPianw() {
        var _this = this;
        this.myplayer && this.myplayer.pause();
        this.myplayer.dispose();
        this.myplayer = null;
        var myvid = "dc71da40a29171ed9d766eb3690d0102";
        var mysource = this.pwPass;
        this.isBfkc = false;
        _this.myplayer = new Aliplayer({
          id: "J_prismPlayer", // 容器id
          vid: myvid,
          playauth: mysource,
          autoplay: true, // 是否自动播放
          width: "100%", // 播放器宽度
          height: "454px", // 播放器高度
          playsinline: true,
          seekable: true,
          controlBarVisibility: 'hover',
          skinLayout: [{
            "name": "bigPlayButton",
            "align": "cc"
          }]
        });
      }
    },
    components: {},
    created: function() {
      this.maxPercent = this.kcdata.percent ? parseFloat(this.kcdata.percent) : 0;
    },
    watch: {
      videoSrc(val, oldVal) { //普通的watch监听

      },
      kcdata: { //深度监听，可监听到对象、数组的变化
        handler(val, oldVal) {
          if (this.myplayer) {
            this.myplayer && this.myplayer.pause();
            this.myplayer.dispose();
            this.myplayer = null;
            // this.getVideoPiant();
            this.getVideoVid()
          } else {
            // this.getVideoPiant();

            this.getVideoVid()
          }
        },
        deep: true //true 深度监听
      },
    },
    mounted: function() {
      var $this = this;
    }
  }
</script>

<style>
  .pdc-top-yes-jj {
    opacity: 1;
    background: #333333;
    color: #fff;
    padding: 12px 40px 14px 28px;
    text-align: left;
  }

  .pdc-top-yes-jj-l {
    width: calc(100% - 400px - 68px);
    font-size: 20px;
    letter-spacing: 1px;
  }

  .pdc-top-yes-jj-l-time {
    margin-top: 8px;
    color: #dfdfdf;
    letter-spacing: 1px;
    font-size: 14px;
  }

  .pdc-top-yes-jj-r {
    padding-top: 15px;
  }

  .pdc-bot-l {
    background-color: #fff;
    width: 856px;
    border-radius: 4px;
    box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.03);
    padding: 0 0 20px 0;
  }

  .pdc-bot-l .el-tabs__item {
    height: 58px;
    line-height: 58px;
    padding: 0 33px;
  }

  .pdc-bot-l .el-tabs--top .el-tabs__item.is-top:nth-child(2) {
    padding: 0 33px;
  }

  .pdc-bot-r {
    width: 326px;
    opacity: 1;
    background: #ffffff;
    border-radius: 4px;
  }

  .YanzhenQdBtn {
    width: 120px;
    height: 44px;
    border-radius: 25px;
    font-size: 16px;
    font-family: ' PingFangSC';
  }

  .el-slider__runway.disabled .el-slider__bar {
    background-color: #0071ba;
  }

  .playBtnBig {
    position: absolute;
    top: 50%;
    left: 50%;
    margin: -75px 0 0 -75px;
    opacity: 0;
  }

  .MyvidioAll {
    width: 100%;
    height: 100%;
  }

  .MyvidioAll:hover .playBtnBig {
    opacity: 0.8;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/MyVideo.vue